// utils/permissions.js
import { useSelector } from "react-redux";

export const useHasPermission = () => {
  const permissions = useSelector((state) => state.auth.permissions);

  const hasPermission = (permission) => {
    if (!permissions || permissions.length === 0) return false;
    return permissions.includes(permission);
  };

  return hasPermission;
};
